<template>
  <button v-on:click="returnBook">
    <span>{{ buttonText }}</span>
    <spinner v-if="loading" :size="'0.5em'" style="display: inline-block; margin-left: 0.5em;"></spinner>
    <template v-else-if="errorMessage">
      <br><i class="u-dimmed">{{ errorMessage }}</i>
    </template>
  </button>
</template>

<script>
import Spinner from './Spinner'
export default {
  components: {
    Spinner
  },

  props: {
    buttonText: {
      type: String,
      default: ''
    },
    returnUrl: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      loading: false,
      errorMessage: null
    }
  },

  methods: {
    returnBook () {
      this.loading = true
      this.errorMessage = null

      return window.fetch(this.returnUrl, { method: 'POST' })
        .then((res) => res.json())
        .then((value) => this.$store.dispatch('returnBook', value))
        .catch(() => {
          this.errorMessage = this.$i18n.t('return_book_error')
          this.loading = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ReturnBookButton.vue